var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars"},_vm._l((_vm.total),function(index){return _c('LucideIcon',{key:index,attrs:{"name":"Star","size":_vm.size,"fill":_vm.getFill(index),"stroke":_vm.getStroke(index)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }